import { apiRequest } from "../utils/api";

const getDetectionLogs = async ({ page, limit, startDate, endDate, stage }) => {
  const { data } = await apiRequest.get("/api/pii-detection-logs", {
    params: { page, limit, startDate, endDate, stage },
  });
  return data;
};

const getOccurrences = async ({ page, limit, startDate, endDate, source }) => {
  const { data } = await apiRequest.get("/api/ai/pii-logs/occurrences", {
    params: { page, limit, startDate, endDate, source },
  });
  return data;
};

const PiiAdminService = { getDetectionLogs, getOccurrences };

export default PiiAdminService;
